// Donor-scope donations API helper — CHG-1513 portal-pivot retarget.
//
// Backend: portal.py canonical at GET /api/v1/my-giving/donations
// (PortalDonationPagedEnvelope: flat {data, page, per_page, total,
// total_pages}). Replaces the CHG-1479 (α.2) shim that called the
// now-dropped /api/v1/me/donations router.
//
// Page-indexing: portal BE is 1-indexed, FE ListPage is 0-indexed.

import { apiClient } from "./client";
import type { PortalDonationRead } from "./me-overview";

export interface PortalDonationPagedEnvelope {
  data: PortalDonationRead[];
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

export interface ListMyDonationsParams {
  page?: number;
  pageSize?: number;
  sortField?: string;
  sortDirection?: "asc" | "desc";
  search?: string;
  org_id?: string;
}

export async function listMyDonations(
  params: ListMyDonationsParams = {},
): Promise<{ items: PortalDonationRead[]; total: number }> {
  const r = await apiClient().get<PortalDonationPagedEnvelope>(
    "/my-giving/donations",
    {
      params: {
        page: (params.page ?? 0) + 1,
        per_page: params.pageSize ?? 25,
        org_id: params.org_id,
      },
    },
  );
  return { items: r.data.data, total: r.data.total };
}

export const meDonationsApi = {
  listMyDonations,
};
